module.exports = __webpack_public_path__ + "static/media/1920-service-1-5-min.d8cc9862.jpg";